/**
 * Form Enums for COGS Management System
 * 
 * This file contains all the dropdown/enum values used in the COGS creation form.
 * These values can be easily modified here without changing the form components.
 */

import cc from 'currency-codes';

// Payout Connector options
export const PAYOUT_CONNECTOR_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'BCA_FIRECASH', label: 'BCA Firecash' },
  { value: 'BCA_APIFIRE', label: 'BCA APIFire' },
  { value: 'BNI', label: 'BNI' },
  { value: 'BRI', label: 'BRI' },
  { value: 'BSS', label: 'BSS' },
  { value: 'CIMB', label: 'CIMB' },
  { value: 'Dana', label: 'Dana' },
  { value: 'DBS', label: 'DBS' },
  { value: 'Prima', label: 'Prima' },
  { value: 'LinkAja', label: 'LinkAja' },
  { value: 'OVO', label: 'OVO' },
  { value: 'Permata', label: 'Permata' },
  { value: 'Shopeepay', label: 'Shopeepay' },
  { value: 'BCA', label: 'BCA' },
  { value: 'Mandiri', label: 'Mandiri' },
  { value: 'UBP', label: 'UBP' },
  { value: 'GCASH', label: 'GCash' },
  { value: 'DragonPay', label: 'DragonPay' },
  { value: 'SBC', label: 'SBC' },
  { value: 'BPI', label: 'BPI' },
  { value: 'UOB', label: 'UOB' },
  { value: 'BAY', label: 'BAY' },
  { value: 'KKB', label: 'KKB' },
  { value: 'APPOTAPAY', label: 'APPOTAPAY' },
  { value: 'MONATO', label: 'MONATO' },
  { value: 'STANDARD_CHARTERED', label: 'Standard Chartered' },
  { value: 'CIMB_MANUAL', label: 'CIMB Manual' },
  { value: 'BCA_OFFLINE', label: 'BCA Offline' },
  { value: 'MANDIRI_OFFLINE', label: 'Mandiri Offline' },
  { value: 'CIMB_UUS', label: 'CIMB UUS' },
  { value: 'INTERSEND', label: 'Intersend' },
  { value: 'THUNES', label: 'Thunes' },
  { value: 'SECURITY_BANK', label: 'Security Bank' },
  { value: 'ALTERRA', label: 'Alterra' },
  { value: 'RHB', label: 'RHB' },
];

// Payout Rail options
export const PAYOUT_RAIL_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'In-house', label: 'In-house' },
  { value: 'RTOL', label: 'RTOL' },
  { value: 'RTGS', label: 'RTGS' },
  { value: 'BI_FAST', label: 'BI FAST' },
  { value: 'OVO', label: 'OVO' },
  { value: 'Gopay', label: 'Gopay' },
  { value: 'Shopeepay', label: 'Shopeepay' },
  { value: 'Pesonet', label: 'Pesonet' },
  { value: 'Instapay', label: 'Instapay' },
  { value: 'DragonPay', label: 'DragonPay' },
  { value: 'DUITNOW', label: 'DUITNOW' },
  { value: 'ITMX', label: 'ITMX' },
  { value: 'ACH', label: 'ACH' },
  { value: 'FPS', label: 'FPS' },
];

// Industry options
export const INDUSTRY_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'Non Digital', label: 'Non Digital' },
  { value: 'P2P', label: 'P2P' },
  { value: 'Digital', label: 'Digital' },
  { value: 'Donation', label: 'Donation' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Colection', label: 'Collection' },
  { value: 'Bank Deposit', label: 'Bank Deposit' },
  { value: 'Loan Repayment', label: 'Loan Repayment' },
  { value: 'All Others', label: 'All Others' },
  { value: 'Digibanks and Lending', label: 'Digibanks and Lending' },
  { value: 'Package Stores – Beer, Wine, and Liquor', label: 'Package Stores – Beer, Wine, and Liquor' },
  { value: 'Cryptocurrency', label: 'Cryptocurrency' },
  { value: 'Management, Consulting, and Public Relations Services', label: 'Management, Consulting, and Public Relations Services' },
  { value: 'Household Appliances & Electronics', label: 'Household Appliances & Electronics' },
  { value: 'Fast Food Restaurants', label: 'Fast Food Restaurants' },
  { value: 'Advertising', label: 'Advertising' },
  { value: 'Courier Services', label: 'Courier Services' },
  { value: 'Retail (Misc. General Merch Stores)', label: 'Retail (Misc. General Merch Stores)' },
  { value: 'Memberships, club-sports, recreation, athletics', label: 'Memberships, club-sports, recreation, athletics' },
  { value: 'Barber and Beauty Shops', label: 'Barber and Beauty Shops' },
  { value: 'Real estate', label: 'Real estate' },
  { value: 'Furniture', label: 'Furniture' },
  { value: 'Internet Service (ISP)', label: 'Internet Service (ISP)' },
  { value: 'Transportation', label: 'Transportation' },
  { value: 'Travel/Travel Agencies', label: 'Travel/Travel Agencies' },
  { value: 'Grocery/Supermarkets', label: 'Grocery/Supermarkets' },
  { value: 'Logistics', label: 'Logistics' },
  { value: 'Pharmaceutical', label: 'Pharmaceutical' },
  { value: 'Digital Goods - Games', label: 'Digital Goods - Games' },
  { value: 'Petroleum', label: 'Petroleum' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Hospitals / Clinics', label: 'Hospitals / Clinics' },
  { value: 'Schools - Elementary', label: 'Schools - Elementary' },
  { value: 'Government', label: 'Government' },
  { value: 'Hotel / Lodging', label: 'Hotel / Lodging' },
  { value: 'Donations / Charities', label: 'Donations / Charities' },
  { value: 'Professional Services', label: 'Professional Services' },
  { value: 'Record Shops', label: 'Record Shops' },
  { value: 'Utilities (Electric, Gas, Water)', label: 'Utilities (Electric, Gas, Water)' },
  { value: 'Registered Online Gambling', label: 'Registered Online Gambling' },
  { value: 'Telco (Prepaid / Phone Service)', label: 'Telco (Prepaid / Phone Service)' },
  { value: 'Schools - Colleges / Universities', label: 'Schools - Colleges / Universities' },
  { value: 'Medical Services and Health Practitioners', label: 'Medical Services and Health Practitioners' },
  { value: 'Gov\'t and Public Sector', label: 'Gov\'t and Public Sector' },
  { value: 'Government Services', label: 'Government Services' },
  { value: 'Insurance Sales, Underwriting, and Premiums', label: 'Insurance Sales, Underwriting, and Premiums' },
  { value: 'Bridge, Toll Fees Fees – Bridge, Toll', label: 'Bridge, Toll Fees Fees – Bridge, Toll' },
  { value: 'Transportation Services (Not Elsewhere Classified)', label: 'Transportation Services (Not Elsewhere Classified)' },
  { value: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances', label: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances' },
  { value: 'Beauty and Barber Shops', label: 'Beauty and Barber Shops' },
  { value: 'Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses', label: 'Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses' },
  { value: 'Courier Services – Air and Ground, and Freight Forwarders', label: 'Courier Services – Air and Ground, and Freight Forwarders' },
  { value: 'Miscellaneous General Merchandise', label: 'Miscellaneous General Merchandise' },
  { value: 'Restaurants', label: 'Restaurants' },
  { value: 'Household Appliance Stores', label: 'Household Appliance Stores' },
];

// Flow options
export const FLOW_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'One time payment', label: 'One time payment' },
  { value: 'Tokenized', label: 'Tokenized' },
  { value: 'Auto debit', label: 'Auto debit' },
];

// Acquirer options
export const ACQUIRER_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'BCA', label: 'BCA' },
  { value: 'MANDIRI', label: 'Mandiri' },
  { value: 'BRI', label: 'BRI' },
  { value: 'BNI', label: 'BNI' },
  { value: 'CIMB', label: 'CIMB' },
  { value: 'DANA', label: 'DANA' },
  { value: 'MON', label: 'MON' },
  { value: 'HSBCID', label: 'HSBC ID' },
  { value: 'UOBID', label: 'UOB ID' },
  { value: 'MAYBANKID', label: 'Maybank ID' },
  { value: 'PERMATA', label: 'Permata' },
  { value: 'DBSID', label: 'DBS ID' },
  { value: 'BSI', label: 'BSI' },
  { value: 'MNCGPN', label: 'MNCGPN' },
  { value: 'OCBCPBB', label: 'OCBCPBB' },
  { value: 'GLOBALPAY', label: 'GlobalPay' },
  { value: 'PAYMAYA', label: 'PayMaya' },
  { value: 'UBP', label: 'UBP' },
  { value: 'BDO', label: 'BDO' },
  { value: 'BPI', label: 'BPI' },
  { value: 'HSBC', label: 'HSBC' },
  { value: 'UOB', label: 'UOB' },
  { value: 'AMEX', label: 'AMEX' },
  { value: 'FISERV', label: 'Fiserv' },
  { value: 'XENDIT', label: 'Xendit' },
  { value: 'BAY', label: 'BAY' },
  { value: 'GBP', label: 'GBP' },
  { value: 'BBL', label: 'BBL' },
  { value: 'VPBANK', label: 'VPBank' },
  { value: 'LINKAJA', label: 'LinkAja' },
  { value: 'DRAGONPAY', label: 'DRAGONPAY' },
  { value: 'COINS_PH', label: 'Coins PH' },
  { value: 'SCB', label: 'SCB' },
  { value: 'DBS', label: 'DBS' },
  { value: 'OCBC', label: 'OCBC' },
];

// Foreign/Local Merchant options
export const FOREIGN_LOCAL_MERCHANT_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'LOCAL', label: 'Local' },
  { value: 'FOREIGN', label: 'Foreign' },
];

// Fund Source options
export const FUND_SOURCE_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'Personal Bank', label: 'Personal Bank' },
  { value: 'Corporate Bank', label: 'Corporate Bank' },
  { value: 'Personal Card', label: 'Personal Card' },
  { value: 'Corporate Card', label: 'Corporate Card' },
  { value: 'E-Wallet', label: 'E-Wallet' },
  { value: 'PayLater', label: 'PayLater' },
  { value: 'ALIPAY_CN', label: 'Alipay CN' },
  { value: 'ALIPAY_HK', label: 'Alipay HK' },
  { value: 'ALIPAY_TNG', label: 'Alipay TNG' },
  { value: 'ALIPAY_TRUEMONEY', label: 'Alipay TrueMoney' },
  { value: 'ALIPAY_GCASH', label: 'Alipay GCash' },
  { value: 'ALIPAY_DANA', label: 'Alipay DANA' },
];

// Installment Interest options
export const INSTALLMENT_INTEREST_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: '0', label: '0' },
  { value: 'non-zero', label: 'Non-zero' },
];

// Installment Term options
export const INSTALLMENT_TERM_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: '3-month', label: '3 months' },
  { value: '4-month', label: '4 months' },
  { value: '5-month', label: '5 months' },
  { value: '6-month', label: '6 months' },
  { value: '7-month', label: '7 months' },
  { value: '8-month', label: '8 months' },
  { value: '9-month', label: '9 months' },
  { value: '10-month', label: '10 months' },
  { value: '12-month', label: '12 months' },
  { value: 'bi-weekly', label: 'Bi-weekly' },
  { value: '10-20-days', label: '10-20 days' },
  { value: '1-month', label: '1 month' },
  { value: '24-month', label: '24 months' },
  { value: '36-month', label: '36 months' },
];

// Is On Us options
export const IS_ON_US_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'TRUE', label: 'True' },
  { value: 'FALSE', label: 'False' },
];

// Processor options
export const PROCESSOR_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'MPGS', label: 'MPGS' },
  { value: 'CYBS_REST', label: 'CYBS REST' },
  { value: 'CTV', label: 'CTV' },
  { value: 'BCA', label: 'BCA' },
  { value: 'KKI', label: 'KKI' },
  { value: 'SILVERFLOW', label: 'Silverflow' },
  { value: 'GBP', label: 'GBP' },
];

// Card Type options
export const CARD_TYPE_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'CREDIT', label: 'Credit' },
  { value: 'DEBIT', label: 'Debit' },
  { value: 'PREPAID', label: 'Prepaid' },
  { value: 'ALL', label: 'All' },
];

// Card Brand options
export const CARD_BRAND_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'VISA', label: 'Visa' },
  { value: 'MASTERCARD', label: 'Mastercard' },
  { value: 'AMEX', label: 'American Express' },
  { value: 'JCB', label: 'JCB' },
  { value: 'ITMX', label: 'ITMX' },
  { value: 'TPN', label: 'TPN' },
  { value: 'MyDebit', label: 'MyDebit' },
  { value: 'NAPAS', label: 'NAPAS Card' },
  { value: 'ALL', label: 'All' },
];

// Card Local/Foreign options
export const CARD_LOCAL_FOREIGN_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'LOCAL', label: 'Local' },
  { value: 'FOREIGN', label: 'Foreign' },
  { value: 'ALL', label: 'All' },
];

// Card Tier options
export const CARD_TIER_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'CLASSIC', label: 'Classic' },
  { value: 'GOLD', label: 'Gold' },
  { value: 'PLATINUM', label: 'Platinum' },
  { value: 'SIGNATURE', label: 'Signature' },
  { value: 'INFINITE', label: 'Infinite' },
  { value: 'WORLD', label: 'World' },
  { value: 'WORLD_ELITE', label: 'World Elite' },
  { value: 'BLACK', label: 'Black' },
];

// Helper function to get option label by value
export const getOptionLabel = (options, value) => {
  const option = options.find(opt => opt.value === value);
  return option ? option.label : value;
};

// Helper function to get all values from an options array
export const getOptionValues = (options) => {
  return options.map(opt => opt.value);
};

// FX Liquidity Partner options
// Validated with Justin & Ian — only JPMorgan and Standard Chartered
export const FX_LIQUIDITY_PARTNER_OPTIONS = [
  { value: 'JPMORGAN', label: 'JP Morgan' },
  { value: 'STANDARD_CHARTERED', label: 'Standard Chartered' },
];

// FX Base Rate Source options
export const FX_BASE_RATE_SOURCE_OPTIONS = [
  { value: 'LSEG', label: 'LSEG (Refinitiv / Reuters)' },
  { value: 'XE', label: 'XE.com' },
];

// FX Value Date Convention options
export const FX_VALUE_DATE_CONVENTION_OPTIONS = [
  { value: 'T+0', label: 'T+0 (Value Today)' },
];

// ISO 4217 Currency Codes (from currency-codes library)
// Source: https://www.npmjs.com/package/currency-codes
const REAL_X_CURRENCIES = ['XCD', 'XAF', 'XOF', 'XPF'];
export const CURRENCY_ISO_4217_OPTIONS = cc.data
  .filter((c) => c.code && (!c.code.startsWith('X') || REAL_X_CURRENCIES.includes(c.code)))
  .map((c) => ({ value: c.code, label: c.code }))
  .sort((a, b) => a.value.localeCompare(b.value));

// Product-specific industry options
export const EWALLET_INDUSTRY_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'Non Digital', label: 'Non Digital' },
  { value: 'P2P', label: 'P2P' },
  { value: 'Digital', label: 'Digital' },
  { value: 'Donation', label: 'Donation' },
  { value: 'Retail', label: 'Retail' },
];

export const OTC_INDUSTRY_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'Colection', label: 'Collection' },
  { value: 'Bank Deposit', label: 'Bank Deposit' },
  { value: 'Loan Repayment', label: 'Loan Repayment' },
];

export const CARDS_INDUSTRY_OPTIONS = [
  { value: 'N/A', label: 'N/A' },
  { value: 'All Others', label: 'All Others' },
  { value: 'Digibanks and Lending', label: 'Digibanks and Lending' },
  { value: 'Package Stores – Beer, Wine, and Liquor', label: 'Package Stores – Beer, Wine, and Liquor' },
  { value: 'Cryptocurrency', label: 'Cryptocurrency' },
  { value: 'Management, Consulting, and Public Relations Services', label: 'Management, Consulting, and Public Relations Services' },
  { value: 'Household Appliances & Electronics', label: 'Household Appliances & Electronics' },
  { value: 'Fast Food Restaurants', label: 'Fast Food Restaurants' },
  { value: 'Advertising', label: 'Advertising' },
  { value: 'Courier Services', label: 'Courier Services' },
  { value: 'Retail (Misc. General Merch Stores)', label: 'Retail (Misc. General Merch Stores)' },
  { value: 'Memberships, club-sports, recreation, athletics', label: 'Memberships, club-sports, recreation, athletics' },
  { value: 'Barber and Beauty Shops', label: 'Barber and Beauty Shops' },
  { value: 'Real estate', label: 'Real estate' },
  { value: 'Furniture', label: 'Furniture' },
  { value: 'Internet Service (ISP)', label: 'Internet Service (ISP)' },
  { value: 'Transportation', label: 'Transportation' },
  { value: 'Travel/Travel Agencies', label: 'Travel/Travel Agencies' },
  { value: 'Grocery/Supermarkets', label: 'Grocery/Supermarkets' },
  { value: 'Logistics', label: 'Logistics' },
  { value: 'Pharmaceutical', label: 'Pharmaceutical' },
  { value: 'Digital Goods - Games', label: 'Digital Goods - Games' },
  { value: 'Petroleum', label: 'Petroleum' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Hospitals / Clinics', label: 'Hospitals / Clinics' },
  { value: 'Schools - Elementary', label: 'Schools - Elementary' },
  { value: 'Government', label: 'Government' },
  { value: 'Hotel / Lodging', label: 'Hotel / Lodging' },
  { value: 'Donations / Charities', label: 'Donations / Charities' },
  { value: 'Professional Services', label: 'Professional Services' },
  { value: 'Record Shops', label: 'Record Shops' },
  { value: 'Utilities (Electric, Gas, Water)', label: 'Utilities (Electric, Gas, Water)' },
  { value: 'Registered Online Gambling', label: 'Registered Online Gambling' },
  { value: 'Telco (Prepaid / Phone Service)', label: 'Telco (Prepaid / Phone Service)' },
  { value: 'Schools - Colleges / Universities', label: 'Schools - Colleges / Universities' },
  { value: 'Medical Services and Health Practitioners', label: 'Medical Services and Health Practitioners' },
  { value: 'Gov\'t and Public Sector', label: 'Gov\'t and Public Sector' },
  { value: 'Government Services', label: 'Government Services' },
  { value: 'Insurance Sales, Underwriting, and Premiums', label: 'Insurance Sales, Underwriting, and Premiums' },
  { value: 'Bridge, Toll Fees Fees – Bridge, Toll', label: 'Bridge, Toll Fees Fees – Bridge, Toll' },
  { value: 'Transportation Services (Not Elsewhere Classified)', label: 'Transportation Services (Not Elsewhere Classified)' },
  { value: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances', label: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances' },
  { value: 'Beauty and Barber Shops', label: 'Beauty and Barber Shops' },
  { value: 'Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses', label: 'Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses' },
  { value: 'Courier Services – Air and Ground, and Freight Forwarders', label: 'Courier Services – Air and Ground, and Freight Forwarders' },
  { value: 'Miscellaneous General Merchandise', label: 'Miscellaneous General Merchandise' },
  { value: 'Restaurants', label: 'Restaurants' },
  { value: 'Household Appliance Stores', label: 'Household Appliance Stores' },
];
